// @flow strict
import React from 'react';
import styles from './Author.module.scss';

const Author = () => {
  return (
    <div className={styles['author']}>
      <p className={styles['author__bio']}>
        Cảm ơn bạn đã theo dõi bài viết! <a
          className={styles['author__bio-twitter']}
          href="https://www.facebook.com/weird.coon"
          rel="noopener noreferrer"
          target="_blank"
        >
          Follow mình trên Facebook
        </a> để đặt câu hỏi, mắng vốn, hoặc nhận thông tin về bài viết mới.
      </p>
    </div>
  );
};

export default Author;
